import { makeCustomerProduct } from "../models/customer-product.model";
import { makePaymentOption } from "../models/payment-option.model";
import { makeBitcoinTransaction } from "../models/bitcoin-transaction.model";

class TransactionApiService {
  constructor(HttpService, SessionService) {
    'ngInject';

    this.HttpService = HttpService;
    this.SessionService = SessionService;
  }
  
  depositDetails() {
    return this.HttpService.get('/' + this.SessionService.getLocale() + '/transactions/deposit-details').then((details) => {
      details['customerProducts'] =  details['customerProducts'].map((payload) => {
        return makeCustomerProduct(payload);
      });

      details['paymentOptions'] = details['paymentOptions'].map((payload) => {
        return makePaymentOption(payload);
      });

      return details;
    });
  }

  deposit(payload, additionalHeaders = {}) {
    return this.HttpService.post('/' + this.SessionService.getLocale() + '/transactions/deposit', payload, 'json', additionalHeaders);
  }

  withdrawDetails() {
    return this.HttpService.get('/' + this.SessionService.getLocale() + '/transactions/withdraw-details').then((details) => {
      details['customerProducts'] =  details['customerProducts'].map((payload) => {
        return makeCustomerProduct(payload);
      });

      return details;
    });
  }

  withdraw(payload) {
    return this.HttpService.post('/' + this.SessionService.getLocale() + '/transactions/withdraw', payload);
  }

  transfer(payload) {
    return this.HttpService.post('/' + this.SessionService.getLocale() + '/transactions/transfer', payload);
  }

  p2pTransfer(payload) {
    return this.HttpService.post('/' + this.SessionService.getLocale() + '/transactions/p2pTransfer', payload);
  }

  p2pTransferDetails() {
    return this.HttpService.get('/' + this.SessionService.getLocale() + '/transactions/p2pTransfer-details').then((details) => {
      details['customerProducts'] =  details['customerProducts'].map((payload) => {
        return makeCustomerProduct(payload);
      });

      return details;
    });
  }

  getPaymentOptions() {
    return this.HttpService.get('/' + this.SessionService.getLocale() + '/transactions/payment-options').then(paymentOptions => {
      return paymentOptions.map(paymentOptionPayload => makePaymentOption(paymentOptionPayload));
    });
  }

  checkForActiveBitcoinTransaction() {
    return this.HttpService.get('/' + this.SessionService.getLocale() + '/transactions/check-for-active-bitcoin-transaction').then(payload => {
      if (payload.length === 0) {
        return null;
      }

      return makeBitcoinTransaction(payload);
    });
  }

  acknowledgeBitcoinTransaction() {
    return this.HttpService.put('/' + this.SessionService.getLocale() + '/transactions/acknowledge-bitcoin-transaction');
  }

  declineBitcoinTransaction() {
    return this.HttpService.put('/' + this.SessionService.getLocale() + '/transactions/decline-bitcoin-transaction');
  }

  lockRateBitcoinTransaction() {
    return this.HttpService.put('/' + this.SessionService.getLocale() + '/transactions/lock-rate-bitcoin-transaction');
  }

  /**
   * @deprecated use getHistory() of OverviewApiService instead.
   */
  getHistory(payload) {
    const queryParams = this.HttpService.buildQueryParamsFromPayload(payload);
    return this.HttpService.get(`/overview/transaction-history?${queryParams}`);
  }

  condition() {
    return this.HttpService.get('/' + this.SessionService.getLocale() + '/settings-condition');
  }

  createProductPassword(payload) {
    return this.HttpService.post('/' + this.SessionService.getLocale() + '/transactions/product-password/create', payload);
  }

  viewProductPassword(payload) {
    return this.HttpService.post('/' + this.SessionService.getLocale() + '/transactions/product-password/view', payload);
  }
}

export default TransactionApiService;



// WEBPACK FOOTER //
// ./client/app/api/services/transaction.api.service.js